import { serviceInstance as api } from "../service";

export const getOrders = async (params) => {

  const queryParams = new URLSearchParams({
    fechaInicioPedido: params.fechaInicioPedido.replace(/-/g, ""),
    fechaFinPedido: params.fechaFinPedido.replace(/-/g, ""),
    Cliente: params.Cliente.replace('TODOS', '*'),
    Usuario: params.Usuario
  }).toString().replace(/,/g, ',');

  const response = await api().get(
    `/evento/trazabilidad${!!queryParams ? "?" + queryParams : ""}`
  );

  return response.data.result.data;
};

export async function getEventsByOrderId(orderId) {
  "pedido/eventos?id=749575-1-39";
  const queryParams = new URLSearchParams({
    id: orderId /*'749575-1-39' */,
  }).toString();
  const response = await api().get(
    `/pedido/eventos${!!queryParams ? "?" + queryParams : ""}`
  );
  return response.data.result.data;
}

export async function updateOrder(payload) {
  const response = await api().put(
    `/orden`,
    payload
  );
  return response.data.result;
}

